<template>
  <div class="account-login">
    <div class="account-login__socials">
      <form-socials title="Login with" v-if="!isWrapperApp"></form-socials>
    </div>
    <form-errors :errors="errors"></form-errors>
    <form @submit.prevent="onSubmit">
      <div class="row-xy">
        <div class="column small-12">
          <h5 class="form__title form__title--new">Login using your email</h5>
        </div>
        <div class="column small-12">
          <form-input
            v-model="fields.email"
            @input="$v.fields.email.$touch"
            :validation="$v.fields.email"
            :disabled="isFormDisabled"
            name="username"
            type="email"
            :required="true"
            autocomplete="off"
            placeholder="Email"
          >
          </form-input>
        </div>
        <div class="column small-12">
          <form-input
            v-model="fields.password"
            :hideIconOnValue="false"
            @input="$v.fields.password.$touch"
            :disabled="isFormDisabled"
            :validation="$v.fields.password"
            name="password"
            :type="fieldTypePassword"
            :required="true"
            autocomplete="off"
            placeholder="Password"
          >
            <template v-slot:icon>
              <show-password-icon v-if="!isIE" @showPassword="showPassword"></show-password-icon>
            </template>
          </form-input>
        </div>
        <div class="column small-12 account-login__forgotten-column">
          <div class="column small-6">
            <form-checkbox v-model="fields.rememberMe" name="rememberMe" label="Keep Me Logged In">
            </form-checkbox>
          </div>
          <div class="column small-6">
            <div class="account-login__forgotten-password">
              <a @click.prevent="onForgotten">Forgot Password?</a>
            </div>
          </div>
        </div>
      </div>
      <form-submit
        :disabled="loginButtonDisabled"
        :loading="isFormDisabled"
        label="Login"
      ></form-submit>
      <div class="recaptcha-terms">
        Protected by reCAPTCHA ·
        <a href="https://policies.google.com/privacy" v-outer-link>Privacy</a>
        ·
        <a href="https://policies.google.com/terms" v-outer-link>Terms</a>
      </div>
    </form>
  </div>
</template>

<script src="./account-login.js"></script>
<style src="./account-login.scss" lang="scss"></style>
